import { FC } from 'react';
import { IDebugSettings } from '@models/IDebugSettings';
import Switch from '@srm/ui/switch';

export interface IDebugSettingsProps {
    value: IDebugSettings;
    onChange: (value: IDebugSettings) => void;
}

/**
 * Отладочные переключатели. Раньше — отдельная кнопка-выпадайка в шапке, теперь
 * форма внутри раздела «Личные настройки» меню профиля. Условие показа не изменилось:
 * вне PROD рендерит вызывающий, в PROD раздела нет вовсе.
 */
const DebugSettings: FC<IDebugSettingsProps> = ({ value, onChange }: IDebugSettingsProps) => (
    <>
        <div className="rf-navbar-settings-dialog__item">
            <Switch
                label="Уведомлять об ошибках в формулах"
                checked={value.notifyFormulaErrors}
                between={true}
                reverse={true}
                onCheckedChange={(next) => {
                    onChange({ ...value, notifyFormulaErrors: next });
                }}
            />
        </div>
        <div className="rf-navbar-settings-dialog__item">
            <Switch
                label="Показывать идентификаторы кнопок"
                checked={value.showActionKeys}
                between={true}
                reverse={true}
                onCheckedChange={(next) => {
                    onChange({ ...value, showActionKeys: next });
                }}
            />
        </div>
        <div className="rf-navbar-settings-dialog__item">
            <Switch
                label="Отключить подтверждение ухода с несохранёнными данными"
                checked={value.disableUnsavedChangesGuard ?? false}
                between={true}
                reverse={true}
                onCheckedChange={(next) => {
                    onChange({ ...value, disableUnsavedChangesGuard: next });
                }}
            />
        </div>
    </>
);

export default DebugSettings;
